module.exports = __webpack_public_path__ + "static/media/kcna_logo.ec084c72.png";